export function contractDocumentName(contract) {
  const id = String(contract?.IdContrat ?? "").trim();
  if (/^\d+\.\d+$/.test(id)) return id;
  const number = String(contract?.NumeroContrat ?? "").trim();
  const amendment =
    contract?.NumeroAvenant == null || String(contract.NumeroAvenant).trim() === ""
      ? "0"
      : String(contract.NumeroAvenant).trim();
  if (!number) return id || "contrat";
  return `${number}.${amendment}`;
}

const pdfCache = new Map();
const PDF_CACHE_MAX = 6;

export async function loadContractPdf(http, contract) {
  const id = contract?._id;
  if (!id) throw new Error("Contrat sans identifiant");
  if (pdfCache.has(id)) {
    const cached = pdfCache.get(id);
    pdfCache.delete(id);
    pdfCache.set(id, cached);
    return cached;
  }
  const { data } = await http.get(`pld-contract/view/${id}`, { responseType: "blob" });
  const blob = data instanceof Blob ? data : new Blob([data], { type: "application/pdf" });
  const type = String(blob.type || "");
  if (type.includes("json") || type.includes("html")) {
    throw new Error("Le serveur n'a pas renvoyé un PDF");
  }
  const header = await blob.slice(0, 5).text();
  if (!header.startsWith("%PDF")) throw new Error("PDF invalide");
  pdfCache.set(id, blob);
  while (pdfCache.size > PDF_CACHE_MAX) {
    const oldest = pdfCache.keys().next().value;
    pdfCache.delete(oldest);
  }
  return blob;
}

export function presentContractPdf(blob, filename, mode) {
  const file = new File([blob], filename, { type: "application/pdf" });
  const url = URL.createObjectURL(file);
  if (mode === "download") {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } else {
    const opened = window.open(url, "_blank");
    if (!opened) {
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
